<template>
  <div class="spacehall-comp-container">
    <div class="spacehall-comp-wrapper">
      <div class="filter-area">
        <div class="filter-wrapper">
          <div class="title">
            <div class="icon"><img src="@/images/common/screen.png" /></div>
            <div class="text">筛选</div>
          </div>
          <div class="input-group">
            <div class="input-item">
              <el-select
                v-model="portStarts"
                placeholder="选择起始港"
                class="currentCabinHall-select--page"
                clearable
                collapse-tags
                multiple
                @change="StartMethods"
              >
                <el-option
                  v-for="item in screenList.portStartList"
                  :key="item.id"
                  :label="item.nameEn"
                  :value="item.id"
                >
                  <div class="filter-pop-item--select">
                    <div>{{ item.nameEn }}</div>
                    <div>({{ item.name+ " | " + item.countryName }})</div>
                  </div>
 
               </el-option>
              </el-select>
            </div>
            <div class="input-item">
              <el-select
                v-model="portEndIds"
                placeholder="选择目的港"
                class="currentCabinHall-select--page"
                clearable
                collapse-tags
                multiple
                @change="EndMethods"
              >
                <el-option
                  v-for="item in screenList.portEndList"
                  :key="item.id"
                  :label="item.nameEn"
                  :value="item.id"
                >
                  <div class="filter-pop-item--select">
                    <div>{{ item.nameEn }}</div>
                    <div>({{ item.name+ " | " + item.countryName }})</div>
                  </div>
 
                </el-option>
              </el-select>
            </div>
            <div class="input-item">
              <el-select
                v-model="containerType"
                placeholder="选择箱型"
                class="currentCabinHall-select--page"
                clearable
                collapse-tags
                multiple
                @change="boxMethods"
              >
                <el-option
                  v-for="item in boxList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="" v-if="!pageLoading">
        <div class="empty dis_f_c_c" v-loading="loading" v-if="page.total == 0">
          <div class="dis_f_co_c_c">
            <div class="emptyImg">
              <img class="fit" src="@/images/common/empty.png" alt="" />
            </div>
            <div class="emptyTitle">
              暂无查询信息，可更换信息查询或者稍后查询~
            </div>
          </div>
        </div>
        <div class="" v-else>
          <div class="space-area">
            <div class="space-wrapper">
              <div class="space-list-panel" v-loading="loading">
                <div
                  class="space-item pointer"
                  :class="{ 'no-margin': (index + 1) % 3 === 0 }"
                  v-for="(item, index) in spaceList"
                  :key="index"
                  @click="openDetail(item.id)"
                >
                  <div class="top-split">
                    <div class="line"></div>
                  </div>
                  <div class="item-wrapper">
                    <div class="row-1">
                      {{ item.portstartname }} ({{ item.portstartnameCn }}) -
                      {{ item.portendname }}（{{ item.portendnameCn }}）
                    </div>
                    <div class="row-2">
                      <div class="date">
                        {{ item.etdStr.substring(5) }} 开航
                      </div>
                      <div class="type">{{ item.containerTypeStr }}</div>
                    </div>
                    <div class="row-3">
                      <div class="photo">
                        <img :src="item.salesHead" />
                      </div>
                      <div class="info">
                        <div class="name">{{ item.salesName }}</div>
                        <div class="time">{{ item.updateTimeStr }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-split">
                    <div class="line"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-area" v-if="page.total > 0">
            <el-pagination
              background
              :total="page.total"
              :current-page="page.pageNo"
              :page-size="page.pageSize"
              @size-change="handleSizeChange"
              @current-change="inputPageNo"
              layout="prev, pager, next, jumper"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-else class="page-loading" v-loading="pageLoading"></div>
    </div>
    <space-guide v-if="showGuide"></space-guide>
    <space-detail-dialog
      @close="showSpaceDetail = false"
      :id="detailID"
      v-if="showSpaceDetail"
    ></space-detail-dialog>
    <login
      @close="showLogin = false"
      v-if="showLogin"
      @success="() => {}"
      @fail="() => {}"
    ></login>
  </div>
</template>
<script>
import {
  wzgetSpacelook,
  wzspacescreenlist,
} from "@/api/currentCabinHall/currentCabinHall";
import SpaceGuide from "./space-guide.vue";
import { mapState } from "vuex";
export default {
  props: {
    isShow: {
      type: Boolean,
      defalut: false,
    },
  },
  watch: {
    isShow(n, o) {
      console.log("==========space hall组件，isShow变化", n, o);
      if (n) {
        this.showGuide = true;
      }
    },
  },
  data() {
    return {
      containerType: [], //箱型
      spaceList: [], //列表数据
      screenList: [], //筛选
      boxList: [
        { id: "20GP", name: "20GP" },
        { id: "40GP", name: "40GP" },
        { id: "40HQ", name: "40HQ" },
        { id: "40NOR", name: "40NOR" },
      ],
      page: {
        pageNo: 1, //页数
        pageSize: 12, //分页数
        total: 0, //总数
      },
      portStarts: [],
      portEndIds: [],
      form: {
        portStarts: "",
        portEndIds: "",
        num20Str: "",
        num40Str: "",
        num40hqStr: "",
        num40norStr: "",
        numFlag: "",
      },
      detailID: "", //详情id
      showGuide: false,
      showSpaceDetail: false,
      showLogin: false, //登录弹框
      loading: true,
      pageLoading: true,
    };
  },
  components: {
    SpaceGuide,
    SpaceDetailDialog: () => import("./space-detail-dialog"),
  },
  async created() {
    // 初始化引导组件状态
    this.showGuide = this.isShow;
    this.pageLoading = true;
      this.page.pageNo = 1;
    await this.wzspacescreenlist();
    await this.spaceListMethods();
    this.pageLoading = false;
  },
  mounted() {},
  computed: {
    ...mapState("user", {
      userId: (state) => state.userId,
    }),
  },
  methods: {
    refreshFilterAndListPublic() {
      this.page.pageNo = 1;
      this.wzspacescreenlist();
      this.spaceListMethods();
    },
    // 筛选列表
    async wzspacescreenlist() {
      // ==========接口调用==========
      let res;
      let params = {
        spaceType: 1, //现舱1 询盘2
      };
      try {
        res = await wzspacescreenlist(params);
        console.log("wzspacescreenlist", res);
        this.screenList = res;
      } catch (e) {
        console.error(e);
      }
    },
    // 现舱列表
    async spaceListMethods() {
      // ==========接口调用==========
      let res;
      let params = {
        spaceType: 1, //现舱1 询盘2
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        ...this.form,
      };
      this.loading = true;
      try {
        res = await wzgetSpacelook(params);
        this.spaceList = res.rows;
        this.page.total = res.total;
        this.loading = false;
        console.log("现舱", res);
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    // 起始港筛选
    StartMethods() {
      this.form.portStarts = this.portStarts.join(",");
      this.page.pageNo = 1;
      this.spaceListMethods();
    },
    EndMethods() {
      this.form.portEndIds = this.portEndIds.join(",");
      this.page.pageNo = 1;
      this.spaceListMethods();
    },
    boxMethods() {
      // 有值时 numFlag == 1
      if (this.containerType.length > 0) {
        this.form.numFlag = 1;
        this.containerType.forEach((arr) => {
          if (arr == "20GP") {
            this.form.num20Str = "20GP";
          } else if (arr == "40GP") {
            this.form.num40Str = "40GP";
          } else if (arr == "40HQ") {
            this.form.num40hqStr = "40HQ";
          } else if (arr == "40NOR") {
            this.form.num40norStr = "40NOR";
          }
        });
      } else {
        this.form.numFlag = "";
      }
      this.page.pageNo = 1;
      this.spaceListMethods();
    },
    //改变分页数据量
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.spaceListMethods();
    },
    // 当前页码改变
    inputPageNo: function (pageNo) {
      console.log("page chagne:", pageNo);
      this.page.pageNo = pageNo;
      this.spaceListMethods();
    },
    // 详情
    openDetail(id) {
      if (!this.userId) {
        this.showLogin = true;
        return;
      }
      this.detailID = id;
      this.showSpaceDetail = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variable.scss";
$searchHeight: 68px;

@mixin splitTransition {
  transition: all 0.3s;
}
.spacehall-comp-container {
  width: 100%;
  padding: 24px 0 85px;
  background: #f5f9ff;
  min-height: calc(100vh - #{$searchHeight} - #{$navbarHeight});

  .spacehall-comp-wrapper {
    width: 1200px;
    margin: auto;
    .filter-area {
      width: 100%;
      height: 70px;
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 24px;

      .filter-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        .title {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          .icon {
            width: 24px;
            margin-right: 14px;
            img {
              display: block;
              width: 100%;
              height: auto;
            }
          }
          .text {
            font-size: 18px;
            font-weight: bold;
            color: #272a31;
          }
        }
        .input-group {
          width: 1068px;
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .input-item {
            width: 344px;
            height: 34px;
            /deep/ .currentCabinHall-search-auto--page {
              width: 100%;
              height: 100%;
              .el-input {
                width: 100%;
                height: 100%;
                .el-input__inner {
                  width: 100%;
                  height: 100%;
                  font-size: 14px;
                  font-weight: 500;
                  padding: 0 14px;
                  background: #ffffff;
                  border: 1px solid #e7eaef;
                  border-radius: 4px;
                  &:hover {
                    border: 1px solid var(--themeColor);
                  }
                }
              }
            }
            /deep/ .currentCabinHall-select--page {
              width: 100%;
              height: 100%;
              .el-input {
                width: 100%;
                height: 100%;
                .el-input__inner {
                  width: 100%;
                  height: 100%;
                  font-size: 14px;
                  font-weight: 500;
                  padding: 0 14px;
                  background: #ffffff;
                  border: 1px solid #e7eaef;
                  border-radius: 4px;
                  &:hover {
                    border: 1px solid var(--themeColor);
                  }
                }
              }
            }
          }
        }
      }
    }
    .empty {
      width: 100%;
      padding-top: 4%;
      padding-bottom: 2%;
      .emptyImg {
        width: 254px;
        margin-bottom: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .emptyTitle {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #676b76;
      }
    }
    .space-area {
      width: 100%;
      position: relative;
      padding-bottom: 20px;
      .space-wrapper {
        width: 100%;
        .space-list-panel {
          width: 100%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .space-item {
            width: 384px;
            flex: 0 0 auto;
            margin-right: calc((100% - 384px * 3) / 2);
            margin-bottom: 24px;
            position: relative;
            top: 0px;
            overflow: hidden;
            height: 178px;
            background: #ffffff;
            border-radius: 10px;
            .top-split {
              width: 100%;
              position: absolute;
              top: 0px;
              .line {
                margin: auto;
                width: 384px;
                height: 2px;
                background: #e5f2ff;
                border-radius: 10px;
              }
            }
            .bottom-split {
              width: 100%;
              position: absolute;
              bottom: 0px;
              .line {
                margin: auto;
                width: 0px;
                height: 2px;
                background: var(--themeColor);
                border-radius: 10px;
                @include splitTransition();
              }
            }

            .item-wrapper {
              width: 100%;
              padding: 24px 20px 0px;
              .row-1 {
                width: 100%;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                margin-bottom: 8px;
              }
              .row-2 {
                display: flex;
                align-items: center;
                margin-bottom: 30px;
                .date {
                  padding: 0 10px;
                  margin-right: 10px;
                  height: 24px;
                  background: #ffffff;
                  border: 1px solid rgba(0, 153, 255, 0.4);
                  border-radius: 10px 0px 10px 0px;
                  font-size: 12px;
                  font-weight: bold;
                  color: var(--themeColor);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
                .type {
                  font-size: 12px;
                  font-weight: 500;
                  color: #676c77;
                }
              }
              .row-3 {
                display: flex;
                align-items: center;
                .photo {
                  width: 44px;
                  height: 44px;
                  overflow: hidden;
                  border-radius: 50%;
                  margin-right: 12px;
                  img {
                    display: block;
                    width: 100%;
                    height: auto;
                  }
                }
                .info {
                  .name {
                    font-size: 14px;
                    font-weight: bold;
                    color: #373842;
                    margin-bottom: 6px;
                  }
                  .time {
                    font-size: 12px;
                    font-weight: 500;
                    color: #676c77;
                  }
                }
              }
            }
            &.no-margin {
              margin-right: 0;
            }
          }
          .space-item:hover {
            .bottom-split {
              .line {
                width: 384px;
              }
            }
          }
        }
      }
    }
    .pagination-area {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
/deep/ .el-loading-mask {
      z-index: 10;
    }
  .page-loading {
    width: 100%;
    height: 340px;
    background: #f5f9ff;
    /deep/ .el-loading-mask {
      background: #f5f9ff;
      z-index: 10;
    }
  }

}
</style>
